import { type FC, type ReactNode } from "react";

// A Drafting section's editor: its title, name, what to draft, what it reads,
// the lines on where it's saved, and Cancel / Add.
export const SectionEditorLayout: FC<{
  title: string;
  name: ReactNode;
  instructions: ReactNode;
  sources: ReactNode;
  footer: ReactNode;
  error?: ReactNode;
  actions: ReactNode;
}> = ({ title, name, instructions, sources, footer, error, actions }) => (
  <div className="space-y-3 text-[12.5px]">
    <h3 className="text-[14px] font-semibold text-slate-800">{title}</h3>
    <div className="space-y-1">{name}</div>
    <div className="space-y-1">{instructions}</div>
    <div className="space-y-1">
      <p className="font-medium text-slate-600">Read from</p>
      {sources}
    </div>
    <div className="space-y-0.5 border-t border-slate-100 pt-2 text-[11.5px] text-slate-500">
      {footer}
    </div>
    {error}
    <div className="flex justify-end gap-2">{actions}</div>
  </div>
);
